import { Navigate, Outlet } from "react-router";
import { useFocusedNavigation } from "../../hooks/useFocusedNavigation";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { DISCOVER_DISTRIBUTION } from "../../constants/routes";

/**
 * Route shell for the unified (consolidated) Sellar Distribution checkout.
 * Mounts at /checkout/unified/:sdBasketUuid/* and wraps every child route,
 * including the Stripe return page, in the checkout-focused navigation state.
 */
export const UnifiedCheckoutPage = () => {
  useFocusedNavigation(); // Hides sidebar and basket drawer while in checkout
  const { business } = useSellarCurrentBusiness();

  if (business && !business.Retailer?.id) {
    return <Navigate to={DISCOVER_DISTRIBUTION} replace />;
  }

  return <Outlet />;
};
